var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSelectedThumbsDown = function SvgSelectedThumbsDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8623 11.0391L16.0186 4.28906C15.9672 3.88117 15.7687 3.50606 15.4603 3.23418C15.1519 2.96231 14.7549 2.81236 14.3438 2.8125H2.25C1.95163 2.8125 1.66548 2.93103 1.4545 3.142C1.24353 3.35298 1.125 3.63913 1.125 3.9375V10.125C1.125 10.4234 1.24353 10.7095 1.4545 10.9205C1.66548 11.1315 1.95163 11.25 2.25 11.25H5.27766L7.93406 16.5642C7.98083 16.6577 8.0527 16.7363 8.14162 16.7911C8.23054 16.846 8.333 16.8751 8.4375 16.875C9.18342 16.875 9.89879 16.5787 10.4262 16.0512C10.9537 15.5238 11.25 14.8084 11.25 14.0625V12.9375H15.1875C15.427 12.9376 15.6637 12.8867 15.882 12.7882C16.1003 12.6898 16.2951 12.546 16.4535 12.3664C16.6119 12.1868 16.7303 11.9756 16.8008 11.7467C16.8713 11.5179 16.8923 11.2766 16.8623 11.0391ZM5.0625 10.125H2.25V3.9375H5.0625V10.125Z",
    fill: "#4652B7"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSelectedThumbsDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SelectedThumbsDown.fc8b00f4.svg";
export { ForwardRef as ReactComponent };